import './layer-order';
import 'whatwg-fetch';
import './tailwind.css';
import * as Sentry from '@sentry/react';
import {useEffect} from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter, useLocation} from 'react-router-dom';
import Root from './Root';

Sentry.init(window.sentryInitOptions);

function ScrollToTop() {
  const {pathname} = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

createRoot(document.getElementById('root')).render(
  <BrowserRouter future={{v7_relativeSplatPath: true}}>
    <ScrollToTop/>
    <Root/>
  </BrowserRouter>
  ,
);
